import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import { Field } from 'redux-form';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import TextField from 'components/fields/TextField';

import * as validate from 'utils/validate';
import * as normalize from 'utils/normalize';

const styles = theme => ({
  root: {
    maxWidth: 54,
    flexBasis: 54,
    [theme.breakpoints.down('xs')]: {
      maxWidth: 42,
      flexBasis: 42,
    },
  },
});

const ProductClaimRefillFields = ({ name, classes, onFieldFocus, onFieldBlur, disabled, ...fields }) => {
  const type = get(fields, `${name}.Type`);
  if (type.input.value === 'Recurring' || type.input.value === 'Rental') {
    return (
      <Grid className={classes.root} item>
        <Field
          id="Refill"
          name={`${name}.Refill`}
          label={type.input.value === 'Rental' ? 'Period' : 'Refill'}
          component={TextField}
          validate={[validate.required]}
          normalize={normalize.positiveNumberWithZero}
          disabled={disabled}
          maxLength="3"
          fullWidth
          labelOverlap
          onFocus={event => onFieldFocus({
            Refill: event.target.value,
          })}
          onBlur={(event) => {
            if (event.target.value) {
              onFieldBlur({
                Refill: event.target.value,
              });
            }
          }}
        />
      </Grid>
    );
  }
  return '';
};

ProductClaimRefillFields.propTypes = {
  name: PropTypes.string.isRequired,
  onFieldFocus: PropTypes.func.isRequired,
  onFieldBlur: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
  }).isRequired,
};

ProductClaimRefillFields.defaultProps = {
  disabled: false,
};

export default withStyles(styles)(ProductClaimRefillFields);



// WEBPACK FOOTER //
// ./src/components/workflow/ProductClaim/ProductClaimRefillFields.js